import controller from './cart.controller';
import templateT1 from './templates/cart-t1.view.html';
import templateT10 from './templates/cart-t10.view.html';
import templateBase from './templates/cart-base.view.html';
import templateAD from './templates/cart-base.view-adaptative.html';

let CartComponent = {
  template: changeTemplate,
  controller,
  bindings: {
    shCtrl: '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if (__env.adaptative) {
    return templateAD;
  } else {
    if (response.CART.component == 'template_t1') {
      return templateT1;
    } else if (response.CART.component == 'template_t10') {
      return templateT10;
    } else {
      return templateBase;
    }
  }
}

export default CartComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/cart/cart.component.js
 **/